var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBackButton(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 20,
    viewBox: "0 0 10 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.579 3.02613C10.1905 2.27562 10.1286 1.1264 9.44059 0.459276C8.75262 -0.207847 7.69917 -0.140248 7.08764 0.610264L0.420985 8.79205C-0.140327 9.48093 -0.140328 10.519 0.420983 11.2079L7.08764 19.3897C7.69917 20.1402 8.75262 20.2078 9.44059 19.5407C10.1286 18.8736 10.1905 17.7244 9.579 16.9739L3.89658 9.99998L9.579 3.02613Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackButton);
export default __webpack_public_path__ + "static/media/backButton.48a2220b.svg";
export { ForwardRef as ReactComponent };